import React, { useMemo } from 'react'
import { Box, Button, Hidden, Typography } from '@material-ui/core'
import { mutualTheme } from '~/utils/theme'
import { CheckIcon, Edit2Icon } from '~/assets/icons'
import * as icons from '~/assets/icons'

type Icons = keyof typeof icons

export enum MODAL_TYPE {
  AddressModal,
  ValidateEmailModal,
  ValidatePhoneModal,
  UpdateEmailModal,
  UpdatePhoneModal,
  SocialNetworkInfoModal,
  SuccessValidationPhoneModal,
  SuccessValidationEmailModal
}

export interface PendencyCardProps {
  title?: string,
  icon: Icons,
  description?: string,
  buttonTitle?: string,
  onClick?: () => void,
  isEditable?: boolean,
  isFinished?: boolean,
  finishedText?: string
}

export const PendencyCard: React.FC<PendencyCardProps> = (props) => {
  const { isEditable, isFinished, finishedText, title, icon, description, buttonTitle, onClick } = props

  const Icon = useMemo(() => {
    return icons[icon]
  }, [icon])

  return (
    <Box sx={{
      width: 470,
      height: 210,
      [mutualTheme.breakpoints.down('md')]: {
        width: 380
      },
      [mutualTheme.breakpoints.down('sm')]: {
        width: '90vw'
      },
      borderRadius: 1,
      boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.08)',
      backgroundColor: 'common.white',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      padding: 3
    }}>
      <Box sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between'
      }}>
        <Hidden mdDown>
          <Box sx={{
            backgroundColor: '#F8F8F8',
            width: 52,
            height: 52,
            borderRadius: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {<Icon htmlColor={mutualTheme.palette.textGray2.main} />}
          </Box>
        </Hidden>
        <Box sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          width: 350
        }}>
          <Typography variant={'airbnbH4'}>
            {title}
          </Typography>
          <Typography variant={'airbnbBody1'} sx={{
            color: mutualTheme.palette.textGray2.main,
            marginTop: 1
          }}>
            {description}
          </Typography>
        </Box>
      </Box>
      {
        !isFinished && !isEditable &&
        (
          <Button
            color='secondary'
            variant='contained'
            sx={{ width: '100%', height: '50px' }}
            onClick={onClick}
          >
            <Typography variant={'airbnbBody1'} sx={{ fontWeight: '500' }}>
              {buttonTitle}
            </Typography>
          </Button>
        )
      }
      {
        isFinished &&
        (
          <Button
            color='secondary'
            variant='outlined'
            disabled={true}
            sx={{
              width: '100%',
              height: '50px',
              backgroundColor: mutualTheme.palette.common.white,
              '&:disabled': {
                backgroundColor: mutualTheme.palette.common.white, border: '1px solid #DFDFDF'
              }
            }}
            startIcon={<CheckIcon htmlColor={mutualTheme.palette.textGray2.main} />}
          >
            <Typography variant={'airbnbBody1'} sx={{ fontWeight: '500', color: mutualTheme.palette.textGray2.main }}>
              {finishedText}
            </Typography>
          </Button>
        )
      }
      {
        isEditable &&
        (
          <Button
            color='secondary'
            variant='outlined'
            sx={{ width: '100%', height: 50, backgroundColor: 'common.white', border: '1px solid #DFDFDF' }}
            onClick={onClick}
            startIcon={<Edit2Icon htmlColor={mutualTheme.palette.secondary.main} />}
          >
            <Typography variant={'airbnbBody1'} sx={{ fontWeight: '500', color: mutualTheme.palette.secondary.main }}>
              Editar dados
            </Typography>
          </Button>
        )
      }
    </Box>
  )
}
